<p-confirmDialog key="email" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid2Col">
	<label>Recipients (Seperate multiple with ;):</label>
	<input [(ngModel)]="lstEmail" class="form-control" type="text" placeholder="example@Example.com;test@Access411.com" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onSend()">Send Email</button>
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>
